document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".list-menu > li");
  let activeMenuItem = null;
  let closeTimer = null;

  const enableHoverMenu = () => {
      menuItems.forEach((item) => {
        const detailsElement = item.querySelector("details");
        if (!detailsElement) return;

      // 🖱 Open mega menu on hover
      item.addEventListener("mouseenter", (e) => handleEnter(e, detailsElement));
    });

    document.addEventListener("mousemove", handleMove);
  }

  const disableHoverMenu = () =>{
    menuItems.forEach((item) => {
        item.removeEventListener("mouseenter", (e) => handleEnter(e, detailsElement));
        
        const detailsElement = item.querySelector("details");
        if (!detailsElement) return;
        detailsElement.removeAttribute('open');

      });
      document.removeEventListener("mousemove", handleMove);
      activeMenuItem = null;
  }

  const handleEnter = (e,detailsElement)=>{
    const item = e.currentTarget;
    if (activeMenuItem && activeMenuItem !== item) {
        const prevDetails = activeMenuItem.querySelector("details");
        if (prevDetails) prevDetails.removeAttribute("open");
      }

      detailsElement.setAttribute("open", true);
      activeMenuItem = item;
  }

  const handleMove = (e) =>{
    const insideHeader   = event.target.closest(".header");
    const insideMegaMenu = event.target.closest(".mega-menu__content");

    if (!insideHeader && !insideMegaMenu && activeMenuItem) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        const detailsElement = activeMenuItem.querySelector("details");
        detailsElement?.removeAttribute("open");
        activeMenuItem = null;
      }, 100);
    } else {
      clearTimeout(closeTimer);
    }
  }

  const cheeckScreenSize = (event) =>{
    if(event.matches){
      enableHoverMenu();
    }else{
      disableHoverMenu();
    }
  }

  const mediaQuery = window.matchMedia("(min-width:1024px)");

  mediaQuery.addEventListener("change", cheeckScreenSize);

  cheeckScreenSize(mediaQuery);

 
});
